<template>
    <div class="wrap-content branding-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-4">
                    <h2>Branding Configurations</h2>
                </div>
            </div>
        </div>

        <div class="config-card-switch">
            <div class="row">
                <div class="col-md-12">
                    <div class="card custom-card">
                        <div class="fields-area">
                            <div class="brand-logo-area">
                                <h5>Brand Logo</h5>
                                <div class="row">
                                    <div class="col-md-9">
                                        <base-upload-file
                                            type="logo"
                                            :label-val="'LOGO FOR LIGHT BACKGROUND'"
                                            :placeholder-val="
                                                formData.logo.light.originalName
                                            "
                                            @set-value="
                                                getLightLogoValue($event)
                                            "
                                        ></base-upload-file>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="brand-logo light">
                                            <div
                                                v-if="
                                                    formData.logo &&
                                                    formData.logo.light
                                                "
                                                class="logo-area-preview"
                                                :style="{
                                                    'background-image':
                                                        'url(' +
                                                        imageFilePathLight +
                                                        ')',
                                                }"
                                            ></div>
                                        </div>
                                    </div>
                                    <div class="col-md-9">
                                        <base-upload-file
                                            type="logo"
                                            :label-val="'LOGO FOR DARK BACKGROUND'"
                                            :placeholder-val="
                                                formData.logo.dark.originalName
                                            "
                                            @set-value="
                                                getDarkLogoValue($event)
                                            "
                                        ></base-upload-file>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="brand-logo dark">
                                            <div
                                                v-if="
                                                    formData.logo &&
                                                    formData.logo.dark
                                                "
                                                class="logo-area-preview"
                                                :style="{
                                                    'background-image':
                                                        'url(' +
                                                        imageFilePathDark +
                                                        ')',
                                                }"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="fields-area">
                            <div class="brand-logo-area">
                                <h5>BACKGROUND IMAGES</h5>
                                <div class="row">
                                    <div class="col-md-9">
                                        <base-upload-file
                                                type="logo"
                                                :label-val="'SIGNUP SCREEN IMAGE'"
                                                :placeholder-val="
                                                getFileName(formData,'signup')
                                            "
                                                @set-value="
                                                getSignupImageValue($event)
                                            "
                                        ></base-upload-file>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="brand-logo light">
                                            <div
                                                    v-if="
                                                    formData.bgImages &&
                                                    formData.bgImages.signup
                                                "
                                                    class="logo-area-preview"
                                                    :style="{
                                                    'background-image':
                                                        'url(' +
                                                        imageFilePathSignup  +
                                                        ')',
                                                }"
                                            ></div>
                                        </div>
                                    </div>
                                    <div class="col-md-9">
                                        <base-upload-file
                                                type="logo"
                                                :label-val="'ID CARD SAMPLE'"
                                                :placeholder-val="
                                                getFileName(formData,'idCard')
                                            "
                                                @set-value="
                                                getIdCardValue($event)
                                            "
                                        ></base-upload-file>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="brand-logo dark">
                                            <div
                                                    v-if="
                                                    formData.bgImages &&
                                                    formData.bgImages.idCard
                                                "
                                                    class="logo-area-preview"
                                                    :style="{
                                                    'background-image':
                                                        'url(' +
                                                        imageFilePathIdCard +
                                                        ')',
                                                }"
                                            ></div>
                                        </div>
                                    </div>
                                    <div class="col-md-9">
                                        <base-upload-file
                                                type="logo"
                                                :label-val="'COMPANY LICENSE SAMPLE'"
                                                :placeholder-val="
                                                getFileName(formData,'companyLicense')
                                            "
                                                @set-value="
                                                getCompanyLicenseValue($event)
                                            "
                                        ></base-upload-file>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="brand-logo dark">
                                            <div
                                                    v-if="
                                                    formData.bgImages &&
                                                    formData.bgImages.companyLicense
                                                "
                                                    class="logo-area-preview"
                                                    :style="{
                                                    'background-image':
                                                        'url(' +
                                                        imageFilePathCompanyLicense +
                                                        ')',
                                                }"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="fields-area">
                            <div class="brand-color-area">
                                <h5>Brand Colours</h5>
                                <div class="row">
                                    <div class="col-md-6">
                                        <b-form-group
                                            id="input-group-6"
                                            label="PRIMARY COLOUR CODE"
                                            label-for="primary-code"
                                        >
                                            <div class="color-area">
                                                <b-form-input
                                                    id="primary-code"
                                                    v-model="
                                                        formData.colors.primary
                                                    "
                                                    type="text"
                                                    placeholder="Primary Colour"
                                                ></b-form-input>
                                                <b-form-input
                                                    v-model="
                                                        formData.colors.primary
                                                    "
                                                    type="color"
                                                ></b-form-input>
                                                <div class="input-color">
                                                    <div
                                                        class="color-pallet"
                                                        :style="{
                                                            'background-color':
                                                                '' +
                                                                formData.colors
                                                                    .primary +
                                                                '',
                                                        }"
                                                    ></div>
                                                    <i
                                                        class="
                                                            icon-color-picker
                                                        "
                                                    ></i>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group
                                            id="input-group-6"
                                            label="SECONDARY COLOUR CODE"
                                            label-for="secondary-code"
                                        >
                                            <div class="color-area">
                                                <b-form-input
                                                    id="secondary-code"
                                                    v-model="
                                                        formData.colors
                                                            .secondary
                                                    "
                                                    type="text"
                                                    placeholder="Secondary Colour"
                                                ></b-form-input>
                                                <b-form-input
                                                    v-model="
                                                        formData.colors
                                                            .secondary
                                                    "
                                                    type="color"
                                                ></b-form-input>
                                                <div class="input-color">
                                                    <div
                                                        class="color-pallet"
                                                        :style="{
                                                            'background-color':
                                                                '' +
                                                                formData.colors
                                                                    .secondary +
                                                                '',
                                                        }"
                                                    ></div>
                                                    <i
                                                        class="
                                                            icon-color-picker
                                                        "
                                                    ></i>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group
                                            id="input-group-6"
                                            label="INTERFACE DARK COLOUR CODE"
                                            label-for="interface-dark-code"
                                        >
                                            <div class="color-area">
                                                <b-form-input
                                                    id="interface-dark-code"
                                                    v-model="
                                                        formData.colors.dark
                                                    "
                                                    type="text"
                                                    placeholder="Secondary Colour"
                                                ></b-form-input>
                                                <b-form-input
                                                    v-model="
                                                        formData.colors.dark
                                                    "
                                                    type="color"
                                                ></b-form-input>
                                                <div class="input-color">
                                                    <div
                                                        class="color-pallet"
                                                        :style="{
                                                            'background-color':
                                                                '' +
                                                                formData.colors
                                                                    .dark +
                                                                '',
                                                        }"
                                                    ></div>
                                                    <i
                                                        class="
                                                            icon-color-picker
                                                        "
                                                    ></i>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group
                                            id="input-group-6"
                                            label="INTERFACE DARK MEDIUM DARK COLOUR CODE"
                                            label-for="interface-medium-code"
                                        >
                                            <div class="color-area">
                                                <b-form-input
                                                    id="interface-medium-code"
                                                    v-model="
                                                        formData.colors.light
                                                    "
                                                    type="text"
                                                    placeholder="Secondary Colour"
                                                ></b-form-input>
                                                <b-form-input
                                                    v-model="
                                                        formData.colors.light
                                                    "
                                                    type="color"
                                                ></b-form-input>
                                                <div class="input-color">
                                                    <div
                                                        class="color-pallet"
                                                        :style="{
                                                            'background-color':
                                                                '' +
                                                                formData.colors
                                                                    .light +
                                                                '',
                                                        }"
                                                    ></div>
                                                    <i
                                                        class="
                                                            icon-color-picker
                                                        "
                                                    ></i>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <b-button
                                    type="submit"
                                    variant="primary"
                                    :class="loading ? 'disabled' : ''"
                                    @click.prevent="updateBrandingData()"
                                >
                                    <span class="btn-text">UPDATE</span>
                                    <span class="loader"></span>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- {{ this.formData.logo.dark.fileName }} -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
const viewBrandingResource = new resource('configurations/branding')
// const viewFilesResource = new resource('files')
const fileUrl = process.env.VUE_APP_API_URL

export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'dataSegmentId',
            'loading',
            'data',
            'logoLight',
            'displaySettings',
        ]),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            imageFilePathDark: process.env.VUE_APP_API_URL,
            imageFilePathLight: process.env.VUE_APP_API_URL,
            imageFilePathIdCard: process.env.VUE_APP_API_URL,
            imageFilePathCompanyLicense: process.env.VUE_APP_API_URL,
            imageFilePathSignup: process.env.VUE_APP_API_URL,
            light: false,
            query: {
                dataSegmentId: null,
            },
            formData: {
                colors: {
                    dark: '',
                    light: '',
                    primary: '',
                    secondary: '',
                },
                logo: {
                    dark: {
                        fileName: '',
                        originalName: '',
                    },
                    light: {
                        fileName: '',
                        originalName: '',
                    },
                },
                bgImages: {
                    signup: {
                        fileName: '',
                        originalName: '',
                    },
                    idCard: {
                        fileName: '',
                        originalName: '',
                    },
                    companyLicense: {
                        fileName: '',
                        originalName: '',
                    }
                },
            },
        }
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getBrandingData()
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getLightLogoValue(fileObj) {
            this.formData.logo.light.fileName = fileObj.fileName
            this.formData.logo.light.originalName = fileObj.originalName
            this.imageFilePathLight = fileUrl + 'files/logo/' + fileObj.fileName
        },
        getDarkLogoValue(fileObj) {
            this.formData.logo.dark.fileName = fileObj.fileName
            this.formData.logo.dark.originalName = fileObj.originalName
            this.imageFilePathDark = fileUrl + 'files/logo/' + fileObj.fileName
        },
        getIdCardValue(fileObj) {
            this.formData.bgImages.idCard.fileName = fileObj.fileName
            this.formData.bgImages.idCard.originalName = fileObj.originalName
            this.imageFilePathIdCard = fileUrl + 'files/logo/' + fileObj.fileName
        },
        getCompanyLicenseValue(fileObj) {
            this.formData.bgImages.companyLicense.fileName = fileObj.fileName
            this.formData.bgImages.companyLicense.originalName = fileObj.originalName
            this.imageFilePathCompanyLicense = fileUrl + 'files/logo/' + fileObj.fileName
        },
        getSignupImageValue(fileObj) {
            this.formData.bgImages.signup.fileName = fileObj.fileName
            this.formData.bgImages.signup.originalName = fileObj.originalName
            this.imageFilePathSignup = fileUrl + 'files/logo/' + fileObj.fileName
        },
        getFileName(fileObj,type) {
            if(fileObj.bgImages)
            {
                if(type=='signup')
                {
                    return fileObj.bgImages.signup.originalName
                }
                else if(type=='idCard')
                {
                    return fileObj.bgImages.idCard.originalName
                }
                else
                {
                    return fileObj.bgImages.companyLicense.originalName
                }

            }
            return ''
        },
        async getBrandingData() {
            this.query.dataSegmentId = this.dataSegmentId
            let { data } = await viewBrandingResource.list(this.query)
            this.formData = data.data
            let bgImages = data.data.bgImages
            this.imageFilePathDark =
                fileUrl + 'files/logo/' + data.data.logo.dark.fileName
            this.imageFilePathLight =
                fileUrl + 'files/logo/' + data.data.logo.light.fileName
            if(bgImages != undefined)
            {
                this.imageFilePathSignup =
                    fileUrl + 'files/logo/' + data.data.bgImages.signup.fileName
                this.imageFilePathIdCard =
                    fileUrl + 'files/logo/' + data.data.bgImages.idCard.fileName
                this.imageFilePathCompanyLicense =
                    fileUrl + 'files/logo/' + data.data.bgImages.companyLicense.fileName
            }

        }, // End of getBrandingData() method

        async updateBrandingData() {
            try {
                // Update Config Branding in auth store
                await this.$store.dispatch(
                    'updateConfigBranding',
                    this.formData
                )
                console.log(this.formData)
                this.$store.commit('setDisplaySetting', this.formData)

                await this.getBrandingData()
            } catch (error) {
                console.log(error, 'There is an error update Branding')
            }
        }, // End of updateConfigBranding() method
    }, // End of Component > mounted
} // End of export default
</script>
